<chat-recent></chat-recent>
<span class="font-m font-500 color-white">Chats</span>
@if (totalUnreadCount) { <span class="am-flex-center height-18 pl-xs pr-xs b-radius-wide bg-red color-white font-s roboto word-no-wrap">{{ totalUnreadCount > 99 ? '99+' : totalUnreadCount }} neu</span> }
